import { api } from '@/shared/services/api';

export type SupportChannel =
  | 'in-app'
  | 'email'
  | 'whatsapp'
  | 'phone'
  | 'scheduled-call';

export type SupportStatus =
  | 'open'
  | 'pending_user'
  | 'pending_agent'
  | 'resolved'
  | 'closed';

export type SupportAuthorType = 'user' | 'agent' | 'system' | 'ai';

export interface SupportMessage {
  id: string;
  ticketId: string;
  authorType: SupportAuthorType;
  authorId: string | null;
  body: string;
  attachments: unknown;
  whatsappMsgId: string | null;
  emailMsgId: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface SupportTicket {
  id: string;
  tenantId: string;
  userId: string | null;
  channel: SupportChannel;
  subject: string;
  status: SupportStatus;
  priority: 'low' | 'normal' | 'high' | 'urgent';
  contextData: Record<string, unknown> | null;
  whatsappPhoneE164: string | null;
  emailFrom: string | null;
  assignedToUserId: string | null;
  createdAt: string;
  updatedAt: string;
  resolvedAt: string | null;
  messages?: SupportMessage[];
}

export interface CreateTicketPayload {
  subject: string;
  body: string;
  contextData?: Record<string, unknown>;
  priority?: 'low' | 'normal' | 'high' | 'urgent';
}

export const supportApi = {
  list: (status?: SupportStatus, limit?: number) => {
    const qs = new URLSearchParams();
    if (status) qs.set('status', status);
    if (limit) qs.set('limit', String(limit));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return api.get<{ data: SupportTicket[] }>(`/support/tickets${suffix}`);
  },
  openCount: () => api.get<{ count: number }>('/support/tickets/open-count'),
  get: (id: string) => api.get<SupportTicket>(`/support/tickets/${id}`),
  create: (payload: CreateTicketPayload) =>
    api.post<SupportTicket>('/support/tickets', payload),
  reply: (id: string, body: string) =>
    api.post<SupportMessage>(`/support/tickets/${id}/messages`, { body }),
};
